import React, { useEffect, useState } from 'react'
import { ButtonToolbar } from 'react-bootstrap'
import { connect, useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js'
import { api_gateway } from '../../../conexoes/api'
import '../../../css/painelAdministrativo/pavTela/pavTela.css'
import {
  desabilitarAcoes,
  limpadorFiltros,
  limpouBusca,
  mudarFiltros,
  mudarManejador,
  realizouBusca,
  realizouFiltro,
  revelarBarraFiltragem
} from '../../../redux/actions/index'
import { formatarData } from '../../../utils/formatadorDataTabela'
import MensagemAtencao from '../../componentesModais/mensagens/mensagemAtencao'
import MensagemErro from '../../componentesModais/mensagens/mensagemErro'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'
import Table from '../../Table/index.jsx'

import CadastroTela from './cadastro'

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0

const valorLimite = 50

const TableprimaryKey = 'cd_pav_tela'

function TabelaPavTela() {
  const [spinAtivo, setSpinAtivo] = useState(true)
  const [itens, setItens] = useState([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(false)
  const [cdModulo, setCdModulo] = useState('')
  const [dsModulo, setDsModulo] = useState('')
  const [cdTela, setCdTela] = useState('')
  const [dsTela, setDsTela] = useState('')
  const [dsRota, setDsRota] = useState('')
  const [dsDescricao, setDsDescricao] = useState('')
  const [desativaAtivar, setDesativarAtivar] = useState(false)
  const [mensagemErro, setMensagemErro] = useState(
    'Ocorreu um erro ao executar esta ação'
  )
  const [revelarMensagemAtencao, setRevelarMensagemAtencao] = useState(false)
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [, /* revelarCadastro */ setRevelarCadastro] = useState(false)
  const [, /* revelarEdicao */ setRevelarEdicao] = useState(false)
  const [itensSelecionados, setItensSelecionados] = useState()

  const despacho = useDispatch()
  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let limpouBuscaGeral = useSelector(
    (state) => state.manejadorState.limpouBusca
  )
  let realizouBuscaGeral = useSelector(
    (state) => state.manejadorState.realizouBusca
  )
  let filtros = useSelector((state) => state.filtrosState.filtros)
  let revelarBarraFiltro = useSelector(
    (state) => state.filtrosState.revelarBarraFiltragem
  )
  let realizouFiltragem = useSelector(
    (state) => state.manejadorState.realizouFiltro
  )
  let novaTela = useSelector((state) => state.manejadorState.revelarNovoTela)
  let editarTela = useSelector(
    (state) => state.manejadorState.revelarEditarTela
  )

  let itensVar = []

  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(87) // 'pavTelaTabelaGrid'
      setColetaUsabilidade(false)
    }
  }, [])

  useEffect(() => {
    despacho(revelarBarraFiltragem(false))
    if (!filtros.vazio) {
      despacho(mudarFiltros({ vazio: 'vazio' }))
    }
    despacho(limpadorFiltros(true))
  }, [])

  useEffect(() => {
    setSpinAtivo(true)
    despacho(mudarManejador('tela'))
    despacho(desabilitarAcoes(true))
    async function carregarTabela() {
      //clicou no botão de limpar a busca geral e retorna tudo ao estado original
      if (limpouBuscaGeral) {
        despacho(limpouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão de busca geral
      if (realizouBuscaGeral) {
        despacho(realizouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão para filtro
      if (realizouFiltragem) {
        despacho(realizouFiltro(false))
        restaurarConfigsIniciaisPagina()
      }

      if (conteudoBusca && filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          await contarItens()
          const { data } = await api_gateway.get(
            '/m1/consultar/tela?paginaAtual=' +
              contador +
              '&carregarLimit=' +
              valorLimite +
              '&buscar=' +
              conteudoBusca
          )
          inserirData(data.dados)
        }
      } else if (!filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        const dados = {
          paguinaAtual: contador,
          carregarLimit: valorLimite,
          buscar: conteudoBusca,
          filtros: filtros
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.post('/m1/filtrar/tela', dados)
          inserirData(data.dados)
        }
      } else {
        if (totalPaginas == 0) {
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.get(
            '/m1/consultar/tela?paginaAtual=' +
              contador +
              '&carregarLimit=' +
              valorLimite
          )
          inserirData(data.dados)
        }
      }
      setSpinAtivo(false)
    }
    carregarTabela()
  }, [paginaAtual, conteudoBusca, renderizar, filtros])

  function inserirData(data) {
    for (let i = 0; i < totalItens; i++) {
      if (contador === i) {
        let k = i
        for (let j = 0; j < data.length; j++) {
          itensVar[k] = data[j]
          k++
        }
      }
      if (i == totalItens - 1) {
        setItens(JSON.parse(JSON.stringify(itensVar)))
      }
    }
  }

  async function contarItens() {
    let arrayItens = []
    let apiData = []
    if (controladorPagina <= paginaAtual) {
      if (controladorPagina <= paginaAtual && filtros.vazio) {
        apiData = await api_gateway.get(
          '/m1/consultar/tela?contar="true"&buscar=' + conteudoBusca
        )
      } else {
        const dados = {
          paguinaAtual: contador,
          carregarLimit: valorLimite,
          buscar: conteudoBusca,
          filtros: filtros,
          contar: true
        }
        apiData = await api_gateway.post('/m1/filtrar/tela', dados)
      }
      itensVar = []
      if (apiData.data.dados) {
        totalPaginas = Math.ceil(apiData.data.dados[0].CONTADOR / valorLimite)
        totalItens = apiData.data.dados[0].CONTADOR
        for (var i = 0; i < apiData.data.dados[0].CONTADOR; i++) {
          arrayItens.push(i)
        }
        itensVar = arrayItens
      }
    }
  }

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    totalItens = 0
    setPaginaAtual(1)
  }

  const colunas = [
    {
      dataField: 'cd_pav_tela',
      text: 'ID',
      sort: true,
      headerClasses: 'tabela-coluna-primeira-header nao-selecionavel',
      headerStyle: () => {
        return { width: '130px' }
      },
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'cd_pav_modulo',
      headerClasses: 'nao-selecionavel',
      text: 'ID módulo',
      hidden: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'ds_pav_modulo',
      headerClasses: 'nao-selecionavel',
      text: 'Módulo',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'ds_pav_tela',
      headerClasses: 'nao-selecionavel',
      text: 'Tela',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'ds_descricao',
      headerClasses: 'nao-selecionavel',
      text: 'Descrição',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'ds_rota',
      headerClasses: 'nao-selecionavel',
      text: 'Rota',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'dt_created_at',
      headerClasses: 'nao-selecionavel',
      text: 'Data de criação',
      sort: true,
      formatter: (cell) => {
        if (cell && cell != '0000-00-00 00:00:00') {
          cell = cell.replace('T', ' ').split('.')
          if (cell.length > 0) {
            cell = cell[0]
          }
        }
        return formatarData(cell)
      }
    },
    {
      dataField: 'dt_updated_at',
      text: 'Última alteração',
      sort: true,
      headerClasses: 'tabela-coluna-ultima-header nao-selecionavel',
      formatter: (cell) => {
        if (cell && cell != '0000-00-00 00:00:00') {
          cell = cell.replace('T', ' ').split('.')
          if (cell.length > 0) {
            cell = cell[0]
          }
        }
        return formatarData(cell)
      }
    },
    {
      dataField: 'dt_deleted_at',
      text: colunaAcoes(),
      headerClasses: 'centralizar tabela-coluna-ultima-header nao-selecionavel',
      classes: 'botoes-barra-acoes',
      formatter: (cell, row) => {
        let checado = cell === '0000-00-00 00:00:00' ? true : false
        return (
          <ButtonToolbar>
            <div className="container-switch-menu-dropdown-tabelas">
              <input
                type="checkbox"
                className="flipswitch-tiny-cb"
                name={'name_' + row.cd_pav_tela}
                id={'switch-ativar-desativar' + row.cd_pav_tela}
                checked={checado}
                onClick={() => {
                  handleMensagemAtencao(false)
                  setDesativarAtivar(checado)
                }}
              />
              <label
                className="flipswitch-tiny-label"
                htmlFor={'switch-ativar-desativar' + row.cd_pav_tela}
              >
                <div className="flipswitch-tiny-inner" />
                <div className="flipswitch-tiny-switch" />
              </label>
            </div>
          </ButtonToolbar>
        )
      }
    }
  ]

  function colunaAcoes() {
    return <p className="acoes">Ativo</p>
  }

  async function handleDeletar() {
    setSpinAtivo(true)
    await api_gateway
      .get('/m1/deletar/tela?cd_pav_tela=' + cdTela)
      .then(function () {
        handleMensagemSucesso(false)
        setRenderizar(!renderizar)
        setSpinAtivo(false)
      })
      .catch(function (error) {
        setMensagemErro(error.response.data.info)
        handleMensagemErro(false)
        setSpinAtivo(false)
      })
  }

  function handleMensagemAtencao(confirmacao) {
    if (revelarMensagemAtencao === false) {
      ColetaClickstream(1000) // pavTelaTabelaGridDesativarTela
      setRevelarMensagemAtencao(true)
    } else {
      setRevelarMensagemAtencao(false)
      if (confirmacao === true) {
        ColetaClickstream(1370) // pavTelaTabelaGridDesativarTelaDesativar
        handleDeletar()
      } else {
        ColetaClickstream(1371) // pavTelaTabelaGridDesativarTelaCancelar
      }
    }
  }

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }

  function handleMensagemSucesso() {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
    }
  }

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setItensSelecionados(row)

      setCdModulo(row.cd_pav_modulo)
      setDsModulo(row.ds_pav_modulo)
      setCdTela(row.cd_pav_tela)
      setDsTela(row.ds_pav_tela)
      setDsRota(row.ds_rota)
      setDsDescricao(row.ds_descricao)
      despacho(desabilitarAcoes(false))
    }
  }

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens
  const getTotalItensNaPagina = () => getLimiteNaPagina()

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  const itensSelecionadosTable = itensSelecionados?.[TableprimaryKey]
    ? [itensSelecionados[TableprimaryKey]]
    : []

  return (
    <div className="container-tela">
      <Table
        keyField={TableprimaryKey}
        clickToSelect
        revelarContador
        itens={itens}
        colunas={colunas}
        revelarBarraFiltro={revelarBarraFiltro}
        getTotalItensNaPagina={getTotalItensNaPagina}
        getLimiteNaPagina={getTotalItensNaPagina}
        pagination={{
          paginaAtual,
          valorLimite,
          totalPaginas,
          totalItens,
          contador,
          trocarPagina
        }}
        selection={{
          itensSelecionados: itensSelecionadosTable,
          modeSelection: 'radio',
          handleOnSelect
        }}
      />

      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      {novaTela === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <CadastroTela
              tituloJanela="Cadastrar"
              setRevelarCadastro={setRevelarCadastro}
              setRevelarEdicao={setRevelarEdicao}
              renderizar={renderizar}
              setRenderizar={setRenderizar}
            />
          </div>
        </div>
      )}
      {editarTela === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <CadastroTela
              tituloJanela="Editar"
              cdTela={cdTela}
              cdModulo={cdModulo}
              dsModulo={dsModulo}
              dsRota={dsRota}
              dsNome={dsTela}
              dsDescricao={dsDescricao}
              setRevelarCadastro={setRevelarCadastro}
              setRevelarEdicao={setRevelarEdicao}
              renderizar={renderizar}
              setRenderizar={setRenderizar}
            />
          </div>
        </div>
      )}

      {revelarMensagemSucesso && (
        <MensagemSucesso
          handleMensagemSucesso={handleMensagemSucesso}
          mensagemTitulo="Sucesso"
          mensagemParagrafo1={
            desativaAtivar
              ? 'Tela ' + dsTela + ' desativada.'
              : 'Tela ' + dsTela + ' ativada.'
          }
          mensagemBotao="Continuar"
        />
      )}
      {revelarMensagemAtencao && (
        <MensagemAtencao
          handleMensagemAtencao={handleMensagemAtencao}
          mensagemTitulo={
            desativaAtivar ? 'Desativar ' + dsTela : 'Ativar ' + dsTela
          }
          mensagemParagrafo1={
            desativaAtivar
              ? 'Você está desativando esse registro'
              : 'Você está Ativando esse registro'
          }
          mensagemBotao={desativaAtivar ? 'Desativar' : 'Ativar'}
        />
      )}
      {revelarMensagemErro && (
        <MensagemErro
          handleMensagemErro={handleMensagemErro}
          mensagemTitulo={mensagemErro}
          mensagemParagrafo1="Erro"
          mensagemParagrafo2={mensagemErro}
          mensagemBotao="Retornar"
        />
      )}
    </div>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros
  }
}
//React.memo - nao permitir a renderizacao se o state e o props nao mudarem de estado
export default connect(mapStateToProps)(React.memo(TabelaPavTela))
